import { Card, Divider, Flex, Skeleton } from "antd";

export function EmptyState() {
  return (
    <Flex vertical gap={20}>
      <Skeleton.Input active size="large" block />
      <Skeleton.Input active size="default" block />
      <Card
        title={<Skeleton.Input active size="small" />}
        styles={{
          body: {
            padding: 0,
          },
        }}
      >
        <Flex vertical>
          <Flex
            justify="space-between"
            align="center"
            style={{ padding: "12px 20px" }}
          >
            <Skeleton
              avatar={{
                shape: "circle",
                size: 36,
              }}
              title={{
                style: {
                  width: 150,
                },
              }}
              paragraph={false}
              active
            />
            <Skeleton active paragraph={false} style={{ width: 150 }} />
          </Flex>
          <Divider />
          <Flex
            justify="space-between"
            align="center"
            style={{ padding: "12px 20px" }}
          >
            <Skeleton
              avatar={{
                shape: "circle",
                size: 36,
              }}
              title={{
                style: {
                  width: 150,
                },
              }}
              paragraph={false}
              active
            />
            <Skeleton active paragraph={false} style={{ width: 150 }} />
          </Flex>
          <Divider />
          <Flex
            justify="space-between"
            align="center"
            style={{ padding: "12px 20px" }}
          >
            <Skeleton
              avatar={{
                shape: "circle",
                size: 36,
              }}
              paragraph={false}
              title={{
                style: {
                  width: 150,
                },
              }}
              active
            />
            <Skeleton active paragraph={false} style={{ width: 150 }} />
          </Flex>
          <Divider />
          <Flex
            justify="space-between"
            align="center"
            style={{ padding: "12px 20px" }}
          >
            <Skeleton
              avatar={{
                shape: "circle",
                size: 36,
              }}
              paragraph={false}
              active
              title={{
                style: {
                  width: 150,
                },
              }}
            />
            <Skeleton active paragraph={false} style={{ width: 150 }} />
          </Flex>
        </Flex>
      </Card>
      <Divider />
      <Skeleton.Input active size="large" block />
    </Flex>
  );
}
